import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useLogout } from '../../api/auth';
import { Spinner } from '../ui';
import { Sidebar } from '../layout/Sidebar';

export function ProtectedRoute(): JSX.Element {
  const { isAuthenticated, isLoading } = useAuth();
  const logout = useLogout();

  if (isLoading) {
    return (
      <div className="h-screen flex items-center justify-center bg-surface-base">
        <Spinner size="lg" className="text-accent-brand" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Changed collapsed to false to show text by default (operator setup)
  return (
    <div className="flex h-screen bg-surface-base">
      <Sidebar collapsed={false} onLogout={logout} />
      <main className="flex-1 overflow-hidden">
        <Outlet />
      </main>
    </div>
  );
}
